export const transitions = {
  md: '0.2s ease-in-out',
};
